<ng-container *ngIf="!authenticationRequired || (this.authState$ | async)">
  <ng-content></ng-content>
</ng-container>
